export default class ObjectFabric {
  public static create<T>(type: (new () => T), props: Partial<T>): T {
    const obj = new type();
    if (!!props) {
      Object.assign(obj, props);
    }
    return obj;
  }
}


// WEBPACK FOOTER //
// ./scripts/views/components/objectFabric.ts